/* eslint-disable */ 
import React from 'react';
import ProgramsSectionItem from './ProgramSectionItem';
import arrowForward from './assets/Arrow_Forward.png'
import blackArrow from './assets/blackarrow.png'

function ProgramSection({ programs }) {
    return (
        <section className="programs_section">
            <span className="landing-subtitle">Discover</span>
            <h2 className="section_header">Our Trending Micro-programmes</h2>
            <div className="cards_container">
                <div className="card_carousel">
                    {programs.map(program => (
                        <ProgramsSectionItem key={program.id} program={program} />
                    ))}
                </div>
                <div className="carousel_btn_contianer">
                    <button className="carousel-btn" id="prevBtn" style={{ marginLeft: '-2.5rem' }}>
                        <img src={arrowForward} alt="arrow icon" />
                    </button>
                    <button className="carousel-btn" id="nextBtn">
                        <img src={arrowForward } alt="arrow icon" />
                    </button>
                </div>
            </div>
            <a className="link_btn" href="#">View all Micro-programmes
                <img src={blackArrow} alt="arrow icon" className="btn_icon" /></a>
        </section>
    );
}

export default ProgramSection;